import { Row } from "react-styled-flexboxgrid"
import styled from "styled-components"

export interface FormRowProps {
  align?: "left" | "right"
}

export const FormRow = styled(Row)<FormRowProps>`
  text-align: ${({ align }) => align};
`

FormRow.defaultProps = {
  align: "left",
}
